// Sep constants

// Device Categories:
// These map to types under DeviceCategoryType for the category the device belongs to
// Since the mapping is a list and 0 indexed, it is referenced in this array by index.
export const DEVICE_CATEGORIES = [
  'Programmable Communicating Thermostat',
  'Strip Heaters',
  'Baseboard Heaters',
  'Water Heater',
  'Pool Pump',
  'Sauna',
  'Hot Tub',
  'Smart Appliance',
  'Irrigation Pump',
  'Managed Commercial and Industrial Loads',
  'Simple Misc. Loads',
  'Exterior Lighting',
  'Interior Lighting',
  'Load Control Switch',
  'Energy Management System',
  'Smart Energy Module',
  'Electric Vehicle',
  'EVSE',
  'Virtual or Mixed DER',
  'Reciprocating Engine',
  'Fuel Cell',
  'Photovoltaic System',
  'Combined Heat and Power',
  'Combined PV and Storage',
  'Other Generation System',
  'Other Storage System'
];

/**
 * These map to the types under DerControlType. For Control Modes supported by the DER
 * Since the mapping is a list and 0 indexed, it is referenced in this array by index.
 */
export const DER_CONTROL_TYPE_DESCRIPTION = [
  'Charge mode',
  'Discharge mode',
  'Connect / Disconnect: implies galvanic isolation',
  'Energize / De-Energize',
  'Fixed Power Factor Setpoint when absorbing active power',
  'Fixed Power Factor Setpoint when injecting active power',
  'Reactive Power Setpoint',
  'Charge / Discharge Setpoint',
  'Frequency-Watt Parameterized Mode',
  'Frequency-Watt Curve Mode',
  'High Frequency Ride Through, May Trip Mode',
  'High Frequency Ride Through, Must Trip Mode',
  'High Voltage Ride Through, May Trip Mode',
  'High Voltage Ride Through, Momentary Cessation Mode',
  'High Voltage Ride Through, Must Trip Mode',
  'Low Frequency Ride Through, May Trip Mode',
  'Low Frequency Ride Through, Must Trip Mode',
  'Low Voltage Ride Through, May Trip Mode',
  'Low Voltage Ride Through, Momentary Cessation Mode',
  'Low Voltage Ride Through, Must Trip Mode',
  'Maximum Active Power',
  'Target Reactive Power',
  'Target Active Power',
  'Volt-Var Mode',
  'Volt-Watt Mode',
  'Watt-PowerFactor Mode',
  'Watt-Var Mode'
];

export const SEP_RN_DEFAULT_DER_CONTROL = 'DefaultDERControl';
export const SEP_RN_DER_AVAILABILITY = 'DERAvailability';
export const SEP_RN_DER_CAPABILITY = 'DERCapability';
export const SEP_RN_DER_SETTINGS = 'DERSettings';
export const SEP_RN_DER_STATUS = 'DERStatus';

export const DATE_FORMAT = 'MM/DD/YYYY h:mm:ss A';
export const DATETIME = 'DATETIME';
export const TEXTFIELD = 'TEXTFIELD';
export const ALL_CATEGORIES = 'All Categories';

export const RESOURCE_TYPES = {
  TOPONODE: 'toponode',
  INDENODE: 'indenode',
  DEVICE: 'device',
  AGGREGATOR: 'aggregator',
  CONTROL: 'control',
  CURVE: 'curve',
  METER: 'meter',
  USER: 'user',
  RESPONSE: 'response'
};

export const SIDEPANEL_STATES = {
  READ: 'read',
  UPDATE: 'update',
  CREATE: 'create',
  DELETE: 'delete',
  ADD_EXISTING: 'addExisting'
};

export const SUBMENU_TYPES = {
  TOPOLOGY: 'topology',
  USERS: 'users'
};

export const HIDDEN_TREE_ROOT_ID = 'HIDDEN_ROOT';
export const NO_PARENT_OPTION_VALUE = 'None';
export const NO_CONTROL_OPTION_VALUE = 'None';

export const DEFAULT_TREE_TRANSFORMS = {
  [RESOURCE_TYPES.TOPONODE]: {
    translate: {
      x: 0,
      y: 0
    },
    scale: 1
  },
  [RESOURCE_TYPES.INDENODE]: {
    translate: {
      x: 0,
      y: 70
    },
    scale: 1
  },
  [RESOURCE_TYPES.AGGREGATOR]: {
    translate: {
      x: 0,
      y: 70
    },
    scale: 1
  }
};

export const CONTROL_TYPES = {
  opModConnect: { name: 'Connect (opModConnect)' },
  opModEnergize: { name: 'Energize (opModEnergize)' },
  opModFixedPFAbsorbW: {
    name: 'Fixed PF Absorb Watts (opModFixedPFAbsorbW)',
    unit: 'PF'
  },
  opModFixedPFInjectW: {
    name: 'Fixed PF Inject Watts (opModFixedPFInjectW)',
    unit: 'PF'
  },
  opModFixedVar: { name: 'Fixed Var (opModFixedVar)', unit: '%' },
  opModFixedW: { name: 'Fixed Watts (opModFixedW)', unit: '%' },
  opModFreqWattCurveId: {
    name: 'Freq-Watt Curve (opModFreqWatt)',
    curveType: 0
  },
  opModFreqDroop: { name: 'Frequency-Droop (opModFreqDroop)' },
  opModHFRTMayTripCurveId: {
    name: 'HFRT May Trip Curve (opModHFRTMayTrip)',
    curveType: 1
  },
  opModHFRTMustTripCurveId: {
    name: 'HFRT Must Trip Curve (opModHFRTMustTrip)',
    curveType: 2
  },
  opModHVRTMayTripCurveId: {
    name: 'HVRT May Trip Curve (opModHVRTMayTrip)',
    curveType: 3
  },
  opModHVRTMomentaryCessationCurveId: {
    name: 'HVRT Momentary Cessation Curve (opModHVRTMomentaryCessation)',
    curveType: 4
  },
  opModHVRTMustTripCurveId: {
    name: 'HVRT Must Trip Curve (opModHVRTMustTrip)',
    curveType: 5
  },
  opModLFRTMayTripCurveId: {
    name: 'LFRT May Trip Curve (opModLFRTMayTrip)',
    curveType: 6
  },
  opModLFRTMustTripCurveId: {
    name: 'LFRT Must Trip Curve (opModLFRTMustTrip)',
    curveType: 7
  },
  opModLVRTMayTripCurveId: {
    name: 'LVRT May Trip Curve (opModLVRTMayTrip)',
    curveType: 8
  },
  opModLVRTMomentaryCessationCurveId: {
    name: 'LVRT Momentary Cessation Curve (opModLVRTMomentaryCessation)',
    curveType: 9
  },
  opModLVRTMustTripCurveId: {
    name: 'LVRT Must Trip Curve (opModLVRTMustTrip)',
    curveType: 10
  },
  opModMaxLimW: { name: 'Max Active Power (opModMaxLimW)', unit: '%' },
  rampTms: { name: 'Ramp Rate (rampTms)', unit: 's' },
  opModTargetVar: { name: 'Target Var (opModTargetVar)', unit: 'Var' },
  opModTargetW: { name: 'Target Watts (opModTargetW)', unit: 'W' },
  opModVoltVarCurveId: {
    name: 'Volt-Var Curve (opModVoltVar)',
    curveType: 11
  },
  opModVoltWattCurveId: {
    name: 'Volt-Watt Curve (opModVoltWatt)',
    curveType: 12
  },
  opModWattPFCurveId: {
    name: 'Watt-PF Curve (opModWattPF)',
    curveType: 13
  },
  opModWattVarCurveId: {
    name: 'Watt-Var Curve (opModWattVar)',
    curveType: 14
  }
};

export const DEFAULT_CONTROL_FIELDS = {
  description: '',
  setESDelay: {},
  setESHighFreq: {},
  setESHighVolt: {},
  setESLowFreq: {},
  setESLowVolt: {},
  setESRampTms: {},
  setESRandomDelay: {},
  setGradW: {},
  setSoftGradW: {}
};

export const DEFAULT_CONTROL_FIELDS_LIST_ORDER = [
  'description',
  'setESDelay',
  'setESHighFreq',
  'setESHighVolt',
  'setESLowFreq',
  'setESLowVolt',
  'setESRampTms',
  'setESRandomDelay',
  'setGradW',
  'setSoftGradW'
];

export const DEFAULT_CONTROL_FIELD_UNIT = {
  description: TEXTFIELD,
  setESDelay: 's',
  setESHighFreq: 'Hz',
  setESHighVolt: '%',
  setESLowFreq: 'Hz',
  setESLowVolt: '%',
  setESRampTms: 's',
  setESRandomDelay: 's',
  setGradW: '%setMaxW/s',
  setSoftGradW: '%setMaxW/s'
};

export const DER_AVAILABILITY_UNITS = {
  availabilityDuration: 's',
  maxChargeDuration: 's',
  readingTime: DATETIME,
  reserveChargePercent: '%',
  reservePercent: '%',
  statVarAvail: 'Var',
  statWAvail: 'W'
};

export const DER_SETTINGS_UNITS = {
  setESDelay: 's',
  setESHighFreq: 'Hz',
  setESHighVolt: '%',
  setESLowFreq: 'Hz',
  setESLowVolt: '%',
  setESRampTms: 's',
  setESRandomDelay: 's',
  setGradW: '%setMaxW/s',
  setSoftGradW: '%setMaxW/s',
  setMaxA: 'A',
  setMaxAh: 'W',
  setMaxChargeRateVA: 'VA',
  setMaxChargeRateW: 'W',
  setMaxDischargeRateVA: 'VA',
  setMaxDischargeRateW: 'W',
  setMaxV: 'V',
  setMaxVA: 'VA',
  setMaxVar: 'Var',
  setMaxVarNeg: 'Var',
  setMaxW: 'W',
  setMaxWh: 'Wh',
  setMinPFOverExcited: 'PF',
  setMinPFUnderExcited: 'PF',
  setMinV: 'V',
  setVNom: 'V',
  setVRef: 'V',
  setVRefOfs: 'V',
  updatedTime: DATETIME
};

export const DER_CAPABILITY_UNITS = {
  rtgAbnormalCategory: '',
  rtgMaxA: 'A',
  rtgMaxAh: 'Ah',
  rtgMaxChargeRateVA: 'VA',
  rtgMaxChargeRateW: 'W',
  rtgMaxDischargeRateVA: 'VA',
  rtgMaxDischargeRateW: 'W',
  rtgMaxV: 'V',
  rtgMaxVA: 'VA',
  rtgMaxVar: 'Var',
  rtgMaxVarNeg: 'Var',
  rtgMaxW: 'W',
  rtgMaxWh: 'Wh',
  rtgMinPFOverExcited: 'PF',
  rtgMinPFUnderExcited: 'PF',
  rtgMinV: 'V',
  rtgNormalCategory: '',
  rtgOverExcitedPF: 'PF',
  rtgOverExcitedW: 'W',
  rtgReactiveSusceptance: '',
  rtgUnderExcitedPF: 'PF',
  rtgUnderExcitedW: 'W',
  rtgVNom: 'V',
  type: ''
};

export const DER_TYPES = {
  0: 'Not Applicable',
  1: DEVICE_CATEGORIES[18],
  2: DEVICE_CATEGORIES[19],
  3: DEVICE_CATEGORIES[20],
  4: DEVICE_CATEGORIES[21],
  5: DEVICE_CATEGORIES[22],
  6: DEVICE_CATEGORIES[24],
  80: DEVICE_CATEGORIES[25],
  81: DEVICE_CATEGORIES[16],
  82: DEVICE_CATEGORIES[17],
  83: DEVICE_CATEGORIES[23]
};

export const RTG_NORMAL_CATEGORY_VALUES = {
  0: 'Not Specified',
  1: 'Category A',
  2: 'Category B'
};

export const RTG_ABNORMAL_CATEGORY_VALUES = {
  0: 'Not Specified',
  1: 'Category I',
  2: 'Category II',
  3: 'Category III'
};

export const Y_REF_TYPES = {
  0: 'N/A',
  1: '% Max Power Setting (W)',
  2: '% Max Reactive Power Setting (Var)',
  3: '% Reactive Power Available (Var)',
  4: '% Effective Voltage Setting (V)',
  5: '% Max Charge Rate Setting (W)',
  6: '% Max Discharge Rate Setting (W)',
  7: '% Power Available (W)'
};

export const UNIT_STRINGS = {
  FREQUENCY: 'Hz',
  REACTIVE_POWER: 'Var',
  ACTIVE_POWER: 'W',
  VOLTAGE_RMS: 'V',
  CURRENT_RMS: 'A',
  PERCENT: '%',
  AMP_HOURS: 'Ah',
  APPARENT_POWER: 'VA',
  MAXW_PER_SECOND: '%setMaxW/s',
  POWER_FACTOR: 'PF',
  WATT_HOURS: 'Wh'
};

export const API_FIELD_MAPPINGS = {
  CONTROL_STATUS_DISPLAYS: {
    type: {
      0: {
        displayText: 'Scheduled'
      },
      1: {
        displayText: 'Active'
      },
      2: {
        displayText: 'Cancelled'
      },
      3: {
        displayText: 'Cancelled w/ Randomization'
      },
      4: {
        displayText: 'Superseded'
      }
    }
  },
  CURVE: {
    type: {
      0: {
        displayText: 'Frequency-Watt Curve',
        xLabel: 'Frequency (Hz)',
        yLabel: 'Power (W)',
        yRefTypes: {
          1: Y_REF_TYPES[1]
        }
      },
      1: {
        displayText: 'HFRT May Trip Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Frequency (Hz)',
        yRefTypes: {
          0: Y_REF_TYPES[0]
        }
      },
      2: {
        displayText: 'HFRT Must Trip Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Frequency (Hz)',
        yRefTypes: {
          0: Y_REF_TYPES[0]
        }
      },
      3: {
        displayText: 'HVRT May Trip Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Voltage (V)',
        yRefTypes: {
          4: Y_REF_TYPES[4]
        }
      },
      4: {
        displayText: 'HVRT Momentary Cessation Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Voltage (V)',
        yRefTypes: {
          4: Y_REF_TYPES[4]
        }
      },
      5: {
        displayText: 'HVRT Must Trip Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Voltage (V)',
        yRefTypes: {
          4: Y_REF_TYPES[4]
        }
      },
      6: {
        displayText: 'LFRT May Trip Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Frequency (Hz)',
        yRefTypes: {
          0: Y_REF_TYPES[0]
        }
      },
      7: {
        displayText: 'LFRT Must Trip Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Frequency (Hz)',
        yRefTypes: {
          0: Y_REF_TYPES[0]
        }
      },
      8: {
        displayText: 'LVRT May Trip Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Voltage (V)',
        yRefTypes: {
          4: Y_REF_TYPES[4]
        }
      },
      9: {
        displayText: 'LVRT Momentary Cessation Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Voltage (V)',
        yRefTypes: {
          4: Y_REF_TYPES[4]
        }
      },
      10: {
        displayText: 'LVRT Must Trip Curve',
        xLabel: 'Duration (sec)',
        yLabel: 'Voltage (V)',
        yRefTypes: {
          4: Y_REF_TYPES[4]
        }
      },
      11: {
        displayText: 'Volt-Var Curve',
        xLabel: '% Effective Voltage Setting (V)',
        yLabel: 'Power (W)',
        yRefTypes: {
          1: Y_REF_TYPES[1],
          2: Y_REF_TYPES[2],
          3: Y_REF_TYPES[3]
        }
      },
      12: {
        displayText: 'Volt-Watt Curve',
        xLabel: '% Effective Voltage Setting (V)',
        yLabel: 'Power (W)',
        yRefTypes: {
          1: Y_REF_TYPES[1],
          7: Y_REF_TYPES[7]
        }
      },
      13: {
        displayText: 'Watt-PF Curve',
        xLabel: '% Max Power Setting (W)',
        yLabel: 'Power Factor (PF)',
        yRefTypes: {
          0: Y_REF_TYPES[0]
        }
      },
      14: {
        displayText: 'Watt-Var Curve',
        xLabel: '% Max Power Setting (W)',
        yLabel: 'Power (W)',
        yRefTypes: {
          1: Y_REF_TYPES[1],
          2: Y_REF_TYPES[2],
          3: Y_REF_TYPES[3]
        }
      }
    }
  },
  METER: {
    uom: {
      0: {
        displayText: '',
        displayUnit: ''
      },
      5: {
        displayText: 'A (Current in Amperes (RMS))',
        displayUnit: 'A'
      },
      6: {
        displayText: 'Kelvin (Temperature)',
        displayUnit: 'K'
      },
      23: {
        displayText: 'Degrees Celsius (Relative temperature)',
        displayUnit: '°C'
      },
      29: {
        displayText: 'Voltage',
        displayUnit: 'V'
      },
      31: {
        displayText: 'J (Energy joule)',
        displayUnit: 'J'
      },
      33: {
        displayText: 'Hz (Frequency)',
        displayUnit: 'Hz'
      },
      38: {
        displayText: 'W (Real power in Watts)',
        displayUnit: 'W'
      },
      42: {
        displayText: 'm³ (Cubic Meter)',
        displayUnit: 'm³'
      },
      61: {
        displayText: 'VA (Apparent power)',
        displayUnit: 'VA'
      },
      63: {
        displayText: 'Var (Reactive power)',
        displayUnit: 'Var'
      },
      65: {
        displayText: 'CosTheta (Displacement Power Factor)',
        displayUnit: 'CosTheta'
      },
      67: {
        displayText: 'V² (Volts squared)',
        displayUnit: 'V²'
      },
      69: {
        displayText: 'A² (Amp squared)',
        displayUnit: 'A²'
      },
      71: {
        displayText: 'VAh (Apparent energy)',
        displayUnit: 'VAh'
      },
      72: {
        displayText: 'Wh (Real energy in Watt-hours)',
        displayUnit: 'Wh'
      },
      73: {
        displayText: 'varh (Reactive energy)',
        displayUnit: 'varh'
      },
      106: {
        displayText: 'Ah (Ampere-hours / Available Charge)',
        displayUnit: 'Ah'
      },
      119: {
        displayText: 'ft³ (Cubic Feet)',
        displayUnit: 'ft³'
      },
      122: {
        displayText: 'ft³/h (Cubic Feet per Hour)',
        displayUnit: 'ft³/h'
      },
      125: {
        displayText: 'm³/h (Cubic Meter per Hour)',
        displayUnit: 'm³/h'
      },
      128: {
        displayText: 'US gl (US Gallons)',
        displayUnit: 'US gl'
      },
      129: {
        displayText: 'US gl/h (US Gallons per Hour)',
        displayUnit: 'US gl/h'
      },
      130: {
        displayText: 'IMP gl (Imperial Gallons)',
        displayUnit: 'IMP gl'
      },
      131: {
        displayText: 'IMP gl/h (Imperial Gallons per Hour)',
        displayUnit: 'IMP gl/h'
      },
      132: {
        displayText: 'BTU',
        displayUnit: 'BTU'
      },
      133: {
        displayText: 'BTU/h',
        displayUnit: 'BTU/h'
      },
      134: {
        displayText: 'Liter',
        displayUnit: 'L'
      },
      137: {
        displayText: 'L/h (Liters per Hour)',
        displayUnit: 'L/h'
      },
      140: {
        displayText: 'PA(gauge)',
        displayUnit: 'PA(gauge)'
      },
      155: {
        displayText: 'PA(absolute)',
        displayUnit: 'PA(absolute)'
      },
      169: {
        displayText: 'Therm',
        displayUnit: 'Therm'
      }
    },
    phase: {
      0: {
        displayText: ''
      },
      32: {
        displayText: 'Phase C (and S2)'
      },
      33: {
        displayText: 'Phase CN (and S2N)'
      },
      40: {
        displayText: 'Phase CA'
      },
      64: {
        displayText: 'Phase B'
      },
      65: {
        displayText: 'Phase BN'
      },
      66: {
        displayText: 'Phase BC'
      },
      128: {
        displayText: 'Phase A (and S1)'
      },
      129: {
        displayText: 'Phase AN (and S1N)'
      },
      132: {
        displayText: 'Phase AB 2'
      },
      224: {
        displayText: 'Phase ABC'
      }
    },
    qualifier: {
      0: {
        displayText: ''
      },
      2: {
        displayText: 'Average'
      },
      8: {
        displayText: 'Maximum'
      },
      9: {
        displayText: 'Minimum'
      },
      12: {
        displayText: 'Normal'
      },
      29: {
        displayText: 'σ (Standard Deviation of a Population)'
      },
      30: {
        displayText:
          's (Standard Deviation of a Sample Drawn from a Population)'
      }
    }
  },
  Y_REFERENCE: {
    type: {
      0: 'N/A',
      1: '% Max Power Setting (W)',
      2: '% Max Reactive Power Setting (Var)',
      3: '% Reactive Power Available (Var)',
      4: '% Effective Voltage Setting (V)',
      5: '% Max Charge Rate Setting (W)',
      6: '% Max Discharge Rate Setting (W)',
      7: '% Power Available (W)'
    }
  }
};

export const DB_INT11_MAX_FOR_CURVE_WITH_MULTIPLIER = 2147483647000000; //Max curve number without linter error
export const DB_INT11_MIN_FOR_CURVE_WITH_MULTIPLIER = -2147483648000000; //Min curve number without linter error
export const DB_OVER_EXCITED = 0;
export const DB_UNDER_EXCITED = 1;

export const UNIT_PREFIXES = {
  NANO: { prefix: 'n', name: 'nano' },
  MICRO: { prefix: 'µ', name: 'micro' },
  MILLI: { prefix: 'm', name: 'milli' },
  KILO: { prefix: 'k', name: 'kilo' },
  MEGA: { prefix: 'M', name: 'mega' },
  GIGA: { prefix: 'G', name: 'giga' }
};

export const OP_MOD_FIXED_VAR_REF_TYPES = [
  {
    displayText: 'N/A',
    value: 0
  },
  {
    displayText: 'Max Var %',
    value: 2
  },
  {
    displayText: 'Stat Var Available %',
    value: 3
  }
];

// local storage key
export const CACHED_USER_KEY = 'citadel_user';
export const CACHED_USER_IAT_KEY = 'citadel_user_iat';

export const AUTH_ROLES = {
  ADMIN_CREATE_USER: 'AdminCreateUser',
  ADMIN_WRITE: 'AdminWrite',
  ADMIN_READ: 'AdminRead',
  USER_READ: 'UserRead',
  USER_WRITE: 'UserWrite'
};

export const AUTH_VALUES_TO_ROLES = {
  ADMINCREATEUSER: 'ADMIN_CREATE_USER',
  ADMINWRITE: 'ADMIN_WRITE',
  ADMINREAD: 'ADMIN_READ',
  USERREAD: 'USER_READ',
  USERWRITE: 'USER_WRITE'
};
export const ADMIN_AUTH_ROLES = [
  AUTH_ROLES.ADMIN_CREATE_USER,
  AUTH_ROLES.ADMIN_WRITE,
  AUTH_ROLES.ADMIN_READ
];

export const USER_AUTH_ROLES = [AUTH_ROLES.USER_WRITE, AUTH_ROLES.USER_READ];
export const WRITE_ACCESS_AUTH_ROLES = [
  AUTH_ROLES.ADMIN_CREATE_USER,
  AUTH_ROLES.ADMIN_WRITE,
  AUTH_ROLES.USER_WRITE
];

export const ROLES_DISPLAY_NAMES = {
  AdminCreateUser: 'Admin',
  UserRead: 'User - Read Only',
  UserWrite: 'User'
};

export const USER_FRIENDLY_AUTH_ROLES = {
  ADMIN_CREATE_USER: 'Admin',
  USER_READ: 'User - Read Only',
  USER_WRITE: 'User'
};

export const USER_FRIENDLY_TO_DATABASE_AUTH_ROLES = {
  ADMIN: 'AdminCreateUser',
  USER: 'UserWrite',
  [`USER - READ ONLY`]: 'UserRead'
};

//validation constants
export const SPECIAL_CHARACTERS_ALLOWED = `[A-ZÀ-ÿa-z0-9-,. ']*`;
export const USER_NAME_MAX_LENGTH = 50;
export const EMAIL_MAX_LENGTH = 100;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 50;
export const EMAIL_LOCAL_MAX_LIMIT = 64;
export const EMAIL_FULL_DOMAIN_MAX_LIMIT = 255;
export const EMAIL_SUBDOMAIN_MAX_LIMIT = 63;

export const MAX_SIDEPANEL_WIDTH = 1150;
export const MIN_SIDEPANEL_WIDTH = 350;
export const DEFAULT_SIDEPANEL_WIDTH = 550;

export const ERROR_MESSAGES = {
  WRONG_ENTITY_TYPE: 'Wrong Entity Type',
  SPECIAL_CHARACTERS_ERROR: `Please only use letters, numbers, spaces, or allowed characters (',-.)`,
  EMAIL_ADDRESS_IN_USE_ERROR: 'Email address already in use',
  INVALID_EMAIL_ERROR: `Invalid email. Email addresses must be ${EMAIL_MAX_LENGTH} characters or less and adhere to standard email conventions.`,
  PERMISSION_SETTINGS_REQUIRED: 'Permission settings are required',
  INVALID_PERMISSIONS_ASSIGNMENT: 'Invalid permissions assignment',
  INVALID_PASSWORD:
    'Invalid password. Please check the requirements and try again.',
  PASSWORDS_MUST_MATCH: 'Passwords must match',
  MAX_LENGTH_ERROR: length =>
    `Please use ${length} or less characters for this field`,
  OLD_PASSWORD_REQUIRED: 'Entering your old password is required'
};

export const COMPASS_SERVER_ERROR_MESSAGES = {
  EMAIL_ADDRESS_IN_USE_ERROR: 'Email address already in use',
  OLD_AND_NEW_PASSWORD_REQUIRED:
    'Old password and new password must be provided while trying to change password',
  OLD_PASSWORD_NOT_CORRECT: 'Old password is not correct'
};

// Local or remote values
export const LOCAL_RESOURCE_VALUE_OPTIONS = {
  REMOTE: 'Remote',
  LOCAL: 'Local',
  REMOTE_PLUS_LOCAL: 'Remote'
};

export const MANAGEMENT_TYPE = {
  remote: {
    value: 0
  },
  local: {
    value: 1
  },
  remotePlusLocal: {
    value: 2
  }
};

export const LOCAL_RESOURCE_VALUES = {
  [MANAGEMENT_TYPE.remote.value]: LOCAL_RESOURCE_VALUE_OPTIONS.REMOTE,
  [MANAGEMENT_TYPE.local.value]: LOCAL_RESOURCE_VALUE_OPTIONS.LOCAL,
  [MANAGEMENT_TYPE.remotePlusLocal.value]:
    LOCAL_RESOURCE_VALUE_OPTIONS.REMOTE_PLUS_LOCAL
};

export const LOCAL_RESOURCE_MAPPED_VALUES = {
  REMOTE: MANAGEMENT_TYPE.remote.value,
  LOCAL: MANAGEMENT_TYPE.local.value,
  REMOTE_PLUS_LOCAL: MANAGEMENT_TYPE.remotePlusLocal.value
};

export const PROTOCOL_OPTIONS = {
  2030.5: {
    title: '2030.5',
    value: 0
  },
  Crosslink: {
    title: 'Crosslink',
    value: 1
  }
};

// Table constants
export const defaultRowHeight = 35;
export const defaultSecondaryRowHeight = 25;
export const defaultItemsToDisplayInSingleRow = 4;
